<div class="types_conf">
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
        @for (type of projectTypes; track type) {
            <a mat-tab-link
               class="project_tab"
               (click)="changeType(type)"
               [active]="activeType === type"> {{ type }} </a>
        }
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
<div class="panel">
    <span class="title">My Projects</span>
    <div class="spacer"></div>
    <div class="panel-actions">
        <mat-form-field appearance="outline">
            <inline-svg src="search.svg" color="#A5B5BD" class="search-icon" matPrefix></inline-svg>
            <input matInput [formControl]="projectsSearchCtrl" placeholder="Search by project name">
            @if (projectsSearchCtrl.value.length) {
                <div matSuffix class="search-suffix" (click)="$event.stopPropagation()">
                    <inline-svg
                            src="small_close.svg"
                            color="#A5B5BD"
                            hoverColor="#7F8F98"
                            (click)="clearSearch()"
                    ></inline-svg>
                </div>
            }
        </mat-form-field>
        <button mat-button class="frmg-primary-button header-action" (click)="createProject()">
            <inline-svg src="Plus.svg" class="plus-icon"></inline-svg>
            New Project
        </button>
        <inline-svg src="sort_by.svg" matTooltip="Sort by"
                    [color]="sortTrigger.menuOpen?'#5E84F7':'#A5B5BD'"
                    hoverColor="#7F8F98"
                    [matMenuTriggerFor]="orderMenu"
                    #sortTrigger="matMenuTrigger"
                    [ngClass]="{'active': sortTrigger.menuOpen}"
                    class="action-icon">
        </inline-svg>
        <mat-menu #orderMenu="matMenu">
            @if (activeType !== 'Archived') {
            <button mat-menu-item class="menu-slot" (click)="updateSortState('user_order_index:asc')"
                    [ngClass]="{'active': currentSort === 'user_order_index:asc'}">
                <span>Custom</span>
            </button>
            }
            <button mat-menu-item class="menu-slot" (click)="updateSortState('created_at:desc')"
                    [ngClass]="{'active': currentSort === 'created_at:desc'}">
                <span>Newest first</span>
            </button>
            <button mat-menu-item class="menu-slot" (click)="updateSortState('created_at:asc')"
                    [ngClass]="{'active': currentSort === 'created_at:asc'}">
                <span>Oldest first</span>
            </button>
            <button mat-menu-item class="menu-slot" (click)="updateSortState('name:asc')"
                    [ngClass]="{'active': currentSort === 'name:asc'}">
                <span>A-Z</span>
            </button>
            <button mat-menu-item class="menu-slot" (click)="updateSortState('name:desc')"
                    [ngClass]="{'active': currentSort === 'name:desc'}">
                <span>Z-A</span>
            </button>
        </mat-menu>
        <inline-svg src="tile.svg" matTooltip="View"
                    [color]="viewTrigger.menuOpen?'#5E84F7':'#A5B5BD'"
                    hoverColor="#7F8F98"
                    [matMenuTriggerFor]="viewMenu"
                    #viewTrigger="matMenuTrigger"
                    [ngClass]="{'active': viewTrigger.menuOpen}"
                    class="action-icon">
        </inline-svg>
        <mat-menu #viewMenu="matMenu">
            <button mat-menu-item class="menu-slot" (click)="changeView('list')"
                    [ngClass]="{'active': currentView === 'list'}">
                <span>List View</span>
            </button>
            <button mat-menu-item class="menu-slot" (click)="changeView('tile')"
                    [ngClass]="{'active': currentView === 'tile'}">
                <span>Tile View</span>
            </button>
        </mat-menu>
    </div>
</div>
@if (this.currentView === 'tile' && this.projects.length > 0) {
    <div #contenedor class="projects" cdkDropListGroup>
        @for (item of projects; track item; let i = $index) {
            <div class="projects-item" cdkDropList cdkDropListOrientation="horizontal"
                 [ngClass]="{'archived': item.is_archived}"
                 [cdkDropListData]="{item:item,index:i}" (cdkDropListDropped)="drop($event)"
                 (click)="goToProject(item)">
                <div class="inner" cdkDrag>
                    <div class="placeholder" *cdkDragPlaceholder></div>
                    @if (currentSort === 'user_order_index:asc') {
                        <div class="drag-zone" cdkDragHandle>
                            <inline-svg src="drag.svg" class="drag-icon" color="#A5B5BD"
                                        hoverColor="#7F8F98" parentClass="drag-zone"></inline-svg>
                        </div>
                    }
                    <div class="content" (mousedown)="$event.stopPropagation()"
                         (touchstart)="$event.stopPropagation()">
                        <div class="header">
                            <inline-svg [src]="getProjectIconPath(item)" class="folder-icon"
                                        color="#85BBF3"></inline-svg>
                            <span [matTooltip]="item.name"> {{ item.name | truncate: 32 }}</span>
                            <div class="spacer"></div>
                            <frmg-user-logo-bundle [item]="item" (click)="share(item, $event)"></frmg-user-logo-bundle>
                            <inline-svg src="Hamburger_menu.svg" class="menu-icon"
                                        [color]="menuOpen.menuOpen?'#5E84F7':'#A5B5BD'"
                                        [ngClass]="{'hidden': !hasMenuActions(item)}"
                                        hoverColor="#7F8F98"
                                        [matMenuTriggerFor]="projectMenu"
                                        #menuOpen='matMenuTrigger'
                                        (click)="toggleMenu(item, $event)"></inline-svg>
                            <mat-menu #projectMenu="matMenu" xPosition="before"
                                      (closed)="toggleMenu(null)">
                                @if (!item.is_archived && (item.is_project ? item.is_owned_by_current_user : item.effective_permissions.can_update)) {
                                    <button mat-menu-item (click)="editProject(item)" class="menu-slot"
                                    >
                                        Edit
                                    </button>
                                }
                                @if (!item.is_archived && item.is_owned_by_current_user) {
                                    <button mat-menu-item (click)="share(item)" class="menu-slot"
                                    >
                                        Share
                                    </button>
                                }
                                @if (item.is_owned_by_current_user) {
                                    <button mat-menu-item (click)="archiveProject(item, $event)"
                                            class="menu-slot">
                                        {{ item.is_archived ? 'Unarchive' : 'Archive' }}
                                    </button>
                                }
                                @if (item.is_project ? item.is_owned_by_current_user : item.effective_permissions.can_delete) {
                                    <button mat-menu-item
                                            (click)="deleteProject(item.id, $event)"
                                            class="menu-slot"
                                    >
                                        Delete
                                    </button>
                                }
                                @if (!item.is_archived && !item.is_owned_by_current_user) {
                                    <button mat-menu-item (click)="unfollow(item.id)" class="menu-slot"
                                    >
                                        Remove from the List
                                    </button>
                                }
                            </mat-menu>
                        </div>
                        <div class="about">
                            {{ item.description }}
                        </div>
                        <div class="horizontal-separator"></div>
                        <div class="footer">
                            <!--                        <span class="date">{{ item.last_upload_at | date: "dd/M/yyyy" }}</span>-->
                            <span class="date">{{ item.created_at | date: "dd/M/yyyy" }}</span>
                            <div class="spacer"></div>
                            <inline-svg src="downloads.svg" color="#A5B5BD"></inline-svg>
                            <span>{{ item.downloads_count }}</span>
                            <inline-svg src="Import.svg" color="#A5B5BD"></inline-svg>
                            <span>{{ item.uploads_count }}</span>
                            <inline-svg src="Reports.svg" color="#A5B5BD"></inline-svg>
                            <span>{{ item.reports_count }}</span>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}

@if (this.currentView === 'list' && this.projects.length > 0) {
    <div class="projects-list" cdkDropList (cdkDropListDropped)="dropList($event)">
        @for (item of projects; track item; let i = $index) {
            <div class="project-item" cdkDrag (click)="goToProject(item)"
                 [ngClass]="{'archived': item.is_archived}"
                 [cdkDragDisabled]="currentSort !== 'user_order_index:asc'">
                @if (currentSort === 'user_order_index:asc') {
                    <div class="drag-zone" cdkDragHandle>
                        <inline-svg src="drag.svg" class="drag-icon" color="#A5B5BD" hoverColor="#7F8F98"
                                    parentClass="drag-zone"></inline-svg>
                    </div>
                }
                <div class="labels">
                    <div class="title">
                        <inline-svg [src]="getProjectIconPath(item)" class="folder-icon" color="#85BBF3"></inline-svg>
                        <span> {{ item.name }}</span>
                    </div>
                    <span class="about"> {{ item.description }}</span>
                </div>
                <div class="spacer"></div>
                <div class="info">
                    <span class="date">{{ item.created_at | date: "dd/M/yyyy" }}</span>
                    <div class="info-data">
                        <inline-svg src="downloads.svg" color="#A5B5BD"></inline-svg>
                        <span>{{ item.downloads_count }}</span>
                        <inline-svg src="Import.svg" color="#A5B5BD"></inline-svg>
                        <span>{{ item.uploads_count }}</span>
                        <inline-svg src="Reports.svg" color="#A5B5BD"></inline-svg>
                        <span>{{ item.reports_count }}</span>
                    </div>
                </div>
                <div class="spacer"></div>
                <frmg-user-logo-bundle [item]="item" (click)="share(item, $event)"></frmg-user-logo-bundle>
                <inline-svg src="Hamburger_menu.svg" class="menu-icon"
                            [color]="menuOpen.menuOpen?'#5E84F7':'#A5B5BD'"
                            [ngClass]="{'hidden': !hasMenuActions(item)}"
                            hoverColor="#7F8F98"
                            [matMenuTriggerFor]="projectMenu"
                            #menuOpen='matMenuTrigger'
                            (click)="toggleMenu(item, $event)"></inline-svg>
                <mat-menu #projectMenu="matMenu" xPosition="before"
                          (closed)="toggleMenu(null)">
                    @if (!item.is_archived && (item.is_project ? item.is_owned_by_current_user : item.effective_permissions.can_update)) {
                        <button mat-menu-item (click)="editProject(item)" class="menu-slot"
                        >
                            Edit
                        </button>
                    }
                    @if (!item.is_archived && item.is_owned_by_current_user) {
                        <button mat-menu-item (click)="share(item)" class="menu-slot"
                        >
                            Share
                        </button>
                    }
                    @if (item.is_owned_by_current_user) {
                        <button mat-menu-item (click)="archiveProject(item, $event)"
                                class="menu-slot">
                            {{ item.is_archived ? 'Unarchive' : 'Archive' }}
                        </button>
                    }
                    @if (item.is_project ? item.is_owned_by_current_user : item.effective_permissions.can_delete) {
                        <button mat-menu-item
                                (click)="deleteProject(item.id, $event)"
                                class="menu-slot"
                        >
                            Delete
                        </button>
                    }
                    @if (!item.is_archived && !item.is_owned_by_current_user) {
                        <button mat-menu-item (click)="unfollow(item.id)" class="menu-slot"
                        >
                            Remove from the List
                        </button>
                    }
                </mat-menu>
            </div>
        }
    </div>
}

@if (this.projects.length === 0) {
    <div class="empty-state" [ngClass]="{'spinner' : loadingData}">
        @if (!loadingData) {
            <img src="assets/icons/info-chat.svg" alt="empty list">
            <span class="empty-title">No Projects</span>
            @if (activeType !== 'Archived' && activeType !== 'Shared with me' && projectsSearchCtrl.value.length === 0) {
                <span>Please create new project</span>
            }
            @if (projectsSearchCtrl.value.length) {
                <span>Please try adjusting search or filter to find what you’re looking for.</span>
            }
        }
        @if (loadingData) {
            <span class="empty-title">Loading</span>
        }
    </div>
}